export default "__VITE_PUBLIC_ASSET__96df3657__"